import React, { Component } from 'react';
import Score from 'components/Score';

import './metrics.scss';

export default class MetricsKey extends Component {

    constructor (props) {
        super(props);
    }

	render () {
        let className = 'horizontal';
        if(this.props.orientation) className = this.props.orientation;
		return (
            <div className={`box metrics-key ${className}`}>
                <h4>Color Key</h4>
                <div className="metrics-key-entry">
                    <Score
                        value={100}
                        divisor={100}
                        boxClass="key-color-box"
                        />
                    <span>Mastery</span>
                </div>
                <div className="metrics-key-entry">
                    <Score
                        value={66}
                        divisor={100}
                        boxClass="key-color-box"
                    />
                    <span>Emerging</span>
                </div>
                <div className="metrics-key-entry">
                    <Score
                        value={50}
                        divisor={100}
                        boxClass="key-color-box"
                    />
                    <span>Limited</span>
                </div>
            </div>
		);
	}
}


// WEBPACK FOOTER //
// ./js/components/Metrics/MetricsKey.js